var Handlebars = require("../../../../../../../../../tools/jenkins.plugins.nodejs.tools.NodeJSInstallation/NodeJS_18.16.0/lib/node_modules/@core/macys-cli/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "disabled";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression;

  return "<button "
    + ((stack1 = __default(require("../../../../../@component/common/src/helpers/ifCond.js")).call(alias1,(depth0 != null ? depth0.startOverBtnStatus : depth0),"===","disabled",{"name":"ifCond","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " class=\"start-over "
    + alias3(alias2((depth0 != null ? depth0.startOverBtnStatus : depth0), depth0))
    + " inline pointer fastrewind_"
    + alias3(alias2((depth0 != null ? depth0.buttonColor : depth0), depth0))
    + "-"
    + alias3(alias2((depth0 != null ? depth0.rewindBtnSize : depth0), depth0))
    + "\"\n        title=\"Start Over\" tabindex=\"0\" aria-label=\"Start Over\"></button>\n<button "
    + ((stack1 = __default(require("../../../../../@component/common/src/helpers/ifCond.js")).call(alias1,(depth0 != null ? depth0.prevPageBtnStatus : depth0),"===","disabled",{"name":"ifCond","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " class=\"prev-page "
    + alias3(alias2((depth0 != null ? depth0.prevPageBtnStatus : depth0), depth0))
    + " inline pointer icon-ui-chevron-left-sm-"
    + alias3(alias2((depth0 != null ? depth0.buttonColor : depth0), depth0))
    + "-"
    + alias3(alias2((depth0 != null ? depth0.chevronBtnSize : depth0), depth0))
    + "\"\n        title=\"Previous Page\" tabindex=\"0\" aria-label=\"Previous page\"></button>\n<div  class=\"page-description inline "
    + alias3(alias2((depth0 != null ? depth0.buttonColor : depth0), depth0))
    + "\" > Page "
    + alias3(alias2((depth0 != null ? depth0.currentPage : depth0), depth0))
    + " of "
    + alias3(alias2((depth0 != null ? depth0.maxPage : depth0), depth0))
    + " </div>\n<button "
    + ((stack1 = __default(require("../../../../../@component/common/src/helpers/ifCond.js")).call(alias1,(depth0 != null ? depth0.nextPageBtnStatus : depth0),"===","disabled",{"name":"ifCond","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + " class=\"next-page "
    + alias3(alias2((depth0 != null ? depth0.nextPageBtnStatus : depth0), depth0))
    + " inline pointer icon-ui-chevron-right-sm-"
    + alias3(alias2((depth0 != null ? depth0.buttonColor : depth0), depth0))
    + "-"
    + alias3(alias2((depth0 != null ? depth0.chevronBtnSize : depth0), depth0))
    + "\"\n        title=\"Next Page\" tabindex=\"0\" aria-label=\"Next page\"> </button>\n\n";
},"useData":true});